import axios from 'axios'
import { call, put, takeEvery } from 'redux-saga/effects'
import { SETTINGS_API } from 'constants/url'
import * as actions from './actions'

export function* getCountries() {
  try {
    const response = yield call(axios.get, `${SETTINGS_API}/countries`)
    if (response) {
      const {
        data: { countries }
      } = response
      yield put(actions.settingsGetCountriesSuccess({ countries }))
    }
  } catch (error) {
    yield put(actions.settingsGetCountriesFail(error))
  }
}

export default function*() {
  yield takeEvery(actions.GET_COUNTRIES, getCountries)
}
